$(document).ready(function() {

    if(!$('.featured-services-slideshow').hasClass('slick-initialized')) {
        $('.featured-services-slideshow').slick({
            dots: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 500,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                    autoplay: true,
                    arrows:false,
                    slidesToShow: 1,
                    autoplaySpeed: 4000
                    }
                }
            ]
        });
    }
});